import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class HeaderProviderService {
  public isSearchVisible$ = new BehaviorSubject<boolean>(false);
  public extraClasses$ = new BehaviorSubject<string>('');
  public isMobileMenuOpen$ = new BehaviorSubject<boolean>(false);
}
